import { useEffect, useState } from 'react';
import Menu from '../components/Menu'
import styled from 'styled-components'
import Header from '../components/Header'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useMemo } from 'react';
import { Avatar, Box, Link } from '@mui/material';
import axios from 'axios';
import { apiUrl } from '../utils/common';
import { useNavigate } from 'react-router-dom';
import AddRemoveCandidate from '../components/AddRemoveCandidate';

const PageContainer = styled.div`
    margin-top: 50px;
`;

const ContentWrapper = styled.div`
    box-sizing: border-box;
    margin-top: 20px;
    padding: 0 20px;
    margin-bottom: 20px;
`

const AddProfileForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin:20px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 10px;
`;

const Candidates = () => {
    const navigate = useNavigate();
    const [ candidates, setCandidates ] = useState([]);

    useEffect(() => {
        getCandidates();
    }, [])

    async function getCandidates() {
        try {
          const response = await axios.get(`${apiUrl}/candidates/getCandidates`)
          const data = await response.data;
          setCandidates(data);
        } catch (error) {
          console.error('Error while obtaining candidates:', error);
        }
    };

    const handleRowClick = async (id, candidate) => {
        if (id) {
            navigate(`/candidate/${id}`, { state: { candidate } });
        } else {
            console.error('Invalid candidate Id:', id);
        }
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'twitterAccount',
                header: 'Twitter Account',
                size: 100,
                Cell: ({ row }) => {
                    return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar
                        src={row.original.profile_image_url}
                        alt={row.original.username}
                        sx={{ width: 32, height: 32 }}
                        />
                        <Link
                        href={`https://twitter.com/${row.original.username}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        onClick={(e) => e.stopPropagation()}
                        >
                        @{row.original.username}
                        </Link>
                    </Box>
                    );
                },
            },
            {
                accessorKey: 'following',
                header: 'Following',
                size: 20
            },
            {
                accessorKey: 'followers',
                header: 'Followers',
                size: 20
            },
            {
                accessorKey: 'averageToxicity',
                header: ' Avg. Toxicity',
                size: 20
            },
            {
                accessorFn: (row) => `${row.toxicPostsCount}/${row.totalPosts}`, 
                id: 'toxicPostsRatio',
                header: 'Toxic Posts Ratio',
                size: 20
            },
            {
                id: 'actions',
                enableColumnActions: false,
                size: 200,
                Cell: ({ row }) => (
                <Box onClick={(e) => e.stopPropagation()}>
                   <AddRemoveCandidate candidate={row.original} getCandidates={getCandidates} />
                </Box>
                ),
            },
        ]
    )

    const table = useMaterialReactTable({
        columns,
        data: candidates,
        enableDensityToggle: false,
        enableGlobalFilter: false,
        enableColumnFilters: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        muiTableBodyRowProps: ({ row }) => ({
            onClick: () => handleRowClick(row.original._id, row.original),
            style: { cursor: 'pointer' },
        }),
    })
    
    return (
        <>
            <Menu />
            <PageContainer>
                <Header title='Candidate Accounts' />
                <ContentWrapper>
                    <MaterialReactTable
                        table={table}
                    />
                </ContentWrapper>
            </PageContainer>
        </>
    )
}

export default Candidates